<script>
import { Tiles } from "@/constants/Tiles.const";
import { mapGetters } from "vuex";
import UserService from "@/services/UserService";

export default {
    data() {
        return {
            loading: true,
            show_login_tiles: true
        };
    },
    computed: {
        tiles() {
            return Tiles;
        },
        ...mapGetters("auth", ["getAuthUser"]),
        hasFullOwnAssets() {
            return this.getAuthUser.department_id == 25;
        }
    },
    async created() {
        await this.fetchData();
        this.loading = false;
        this.$watch("show_login_tiles", this.toggle);
    },
    methods: {
        async fetchData() {
            try {
                const { data } = await UserService.GET_tilesSetting();
                this.show_login_tiles = data.data.show_login_tiles;
            } catch (e) {
                console.log("fee", e);
            }
        },
        async toggle() {
            try {
                await UserService.PUT_toggleTilesSetting();
            } catch (e) {
                console.log("fee", e);
            }
        },
        execNavigation(where) {
            this.$emit("close");

            if (where === "CUSTOM_FULL_MB") {
                const route =
                    this.$aclCan(this.$ACL.CUSTOM_FULL_MB) ||
                    this.hasFullOwnAssets
                        ? "/reports/mb-report/dk-assets-full"
                        : "/reports/mb-report/dk-assets";
                this.$router.push(route);
            } else {
                this.$router.push(where);
            }
        }
    }
};
</script>

<template>
    <modal
        :show="true"
        :loading="loading"
        @close="$emit('close')"
        class="modal-tiles"
        size="full"
    >
        <div class="row my-2 px-2">
            <div class="col">
                <input
                    class="ml-2"
                    type="checkbox"
                    v-model="show_login_tiles"
                    value="1"
                />
                {{ $t("tiles.show_tiles_on_login") }}
            </div>
            <div class="col text-right tiles_closer">
                <span class="px-2 m-click" @click="$emit('close')">
                    <i class="far fa-times fa-lg"></i
                ></span>
            </div>
        </div>

        <div class="container-fluid h-100-m">
            <div class="tiles_container row h-100">
                <div
                    class="col-3 tiles_box "
                    v-for="(tile, idx) in tiles"
                    :class="
                        getAuthUser.tiles_config.tiles[idx] === true &&
                        'path' in tiles[idx]
                            ? 'tiles_enabled'
                            : 'tiles_disabled'
                    "
                    :key="idx"
                    @click="
                        getAuthUser.tiles_config.tiles[idx] === true &&
                        'path' in tiles[idx]
                            ? execNavigation(tiles[idx]['path'])
                            : false
                    "
                >
                    <div class="tiles_entry">
                        <div><i :class="tile.icon"></i></div>

                        <div class="tiles_title">
                            {{ tile.name }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<style lang="scss">
.modal-tiles {
    .h-100-m {
        height: calc(100% - 60px) !important;
    }

    .modal-body {
        padding: 0px !important;
    }
}

.tiles {
    &_closer {
        position: absolute;
        right: 4px;
        top: 5px;
    }

    &_container {
    }

    &_box {
        border-top: 1px solid $gray-500;
        border-left: 1px solid $gray-500;
    }

    &_box:nth-child(1) {
        border-top-left-radius: 6px;
    }

    &_box:nth-child(4) {
        border-right: 1px solid $gray-500;
        border-top-right-radius: 6px;
    }

    &_box:nth-child(8) {
        border-right: 1px solid $gray-500;
    }

    &_box:nth-child(9) {
        border-bottom-left-radius: 6px;
    }

    &_box:nth-child(12) {
        border-right: 1px solid $gray-500;
        border-bottom: 1px solid $gray-500;
        border-bottom-right-radius: 6px;
    }

    &_box:nth-child(9),
    &_box:nth-child(10),
    &_box:nth-child(11) {
        border-bottom: 1px solid $gray-500;
    }

    &_entry {
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        transition: background 0.2s ease;
        padding: 1rem;
    }

    &_entry i {
        font-size: 6vw; /* responsive icon size */
        margin-bottom: 0.5rem;
    }

    &_title {
        margin-top: 18px;
        font-size: 1.4vw; /* responsive text size */
        font-weight: 500;
    }

    /* Enabled / disabled */
    &_enabled {
    }

    &_box:hover.tiles_enabled {
        background-color: #f0f0f0;
        cursor: pointer;
    }

    &_disabled {
        * {
            color: $gray-300 !important;
        }
    }
}
</style>
